<div class="dp-header-container">
            <span class="dp-header-label">
                {{ mobileLabel }}
            </span>
    <a (click)="closed.emit(true)"
       id="dp-header-close-btn">
        <span aria-hidden="true"
              class="icon-close"></span>
    </a>
</div>
